import { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext({
  language: "tr",
  setLanguage: () => {},
});

export function LanguageProvider({ children }) {
    
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "tr"
  );

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]); 

  const value = {
    language,
    setLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

localStorage.setItem("test", "merhaba");
localStorage.getItem("test"); // "merhaba" döner
